module.exports = __webpack_public_path__ + "c4d82460ef260eb1589e73528cbfb257.eot";


//////////////////
// WEBPACK FOOTER
// ./~/clarity-ui/dist/fonts/open-sans-regular.eot
// module id = 657
// module chunks = 0